import { render, staticRenderFns } from "./RestrictionBlack.vue?vue&type=template&id=15e31ec0"
import script from "./RestrictionBlack.vue?vue&type=script&lang=js"
export * from "./RestrictionBlack.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports